/* import __COLOCATED_TEMPLATE__ from './root-sum-squared-error.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();